import axios from '@p/utils/request';
import api from '@/api';
import loginAxios from 'axios'
import { configUrl } from '@/utils/config'
import storage from '@/utils/storage'
import { urlEncode } from '@/utils'
import config from '@/config'

// 课程详情
export const getCourseDetailsById = (data) => {
	return axios.get(api.course.getCourseDetailsById,{params:data})
}

// 课堂详情
export const getLessonsDetailsById = (data) => {
	return axios.get(api.course.getLessonsDetailsById,{params:data})
}

// 课件详情
export const getWareDetailsById = (data) => {
	let token = storage.localGet('token');
	return axios.get(api.course.getWareDetailsById, {params: {...data, token}})
}

export const getLmsOSS = (api) => {
	return axios.get(api)
}

// 视频附件地址
export const getVideoWareById = (id, isPublic) => {
	let token = storage.localGet('token');
	return `${!isPublic ? config.interior : config.external}${api.course.getWareDetailsById}?wareId=${id}&token=${token}&isPublic=${isPublic}`;
}

// 获取lms 1.0 流程图
export const getCourseOldFormerFlowchart = (data) => {
	return axios.get(api.course.getCourseOldFormerFlowchart,{params:data})
}

// 绑定课程（立即参加）
export const bindingCourses = (data) => {
	return axios.post(api.course.bindingCourses,data)
}

// 课件视频学习记录
export const wareStudyHistory = (data) => {
	let token = storage.localGet('token');
	const param = {
		...data,
		token
	}
	return axios.post(api.course.wareStudyHistory,param)
}

// 课程考试列表
export const examinations = (data) => {
	return axios.get(api.course.examinations,{params:data})
}

// 课件视频学习记录(同步发送)
export const syncWareStudyHistory = (data) => {
	let token = storage.localGet('token');
	const param = {
		...data,
		token
	}
	if (navigator.sendBeacon) {
		const url = configUrl.baseURL + api.course.wareStudyHistory
		const formData = new FormData();
		Object.keys(param).forEach((key) => {
			let value = param[key];
			if (typeof value !== 'string') {
				value = JSON.stringify(value);
			}
			formData.append(key, value);
		});
		navigator.sendBeacon(url,formData)
	} else {
		let oAjax = new XMLHttpRequest();
		oAjax.open('POST', configUrl.baseURL + api.course.wareStudyHistory, false);//false表示同步请求
		oAjax.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
		// oAjax.setRequestHeader("token", token);
		oAjax.onreadystatechange = function() {
			if (oAjax.readyState == 4 && oAjax.status == 200) {
				console.log(oAjax.responseText)
			} else {
				console.log(oAjax);
			}
		};
		oAjax.send(urlEncode(param).slice(1));
	}
}

let source = ''
// 课件资源超时设置
export const getWareDetailsTimeout = () => {
	const CancelToken = loginAxios.CancelToken;
	source = CancelToken.source();
	return loginAxios.request({
		url: config.wareDetails,
		timeout: 3000,
		cancelToken: source.token
	})
}

export const cancelWareDetailsTimeout = () => {
	source && source.cancel()
}